import axios from "axios";

export async function GetFetchEstados() {
  const axiosInstance = axios.create();
  axiosInstance.defaults.baseURL = "https://gaia.inegi.org.mx/wscatgeo/v2/mgee/";
  const requestConfig = {
    method: "GET",
    url: "",
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(requestConfig);
}
